export default "__VITE_ASSET__YRReapnL__"